/* page-product.js – Ergänzungen für die Produktseite (theme.js bleibt unverändert). */
(() => {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const clean = (value) => String(value || '').replace(/[()]/g, '').trim();

  const money = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    const [int, dec] = (cents / 100).toFixed(2).split('.');
    const apos = int.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return fmt
      .replace(/{{\s*amount\s*}}/, `${apos}.${dec}`)
      .replace(/{{\s*amount_no_decimals\s*}}/, apos)
      .replace(/{{\s*amount_with_comma_separator\s*}}/, `${int},${dec}`)
      .replace(/{{\s*amount_with_apostrophe_separator\s*}}/, `${apos}.${dec}`);
  };

  function initProductExtras(root) {
    $$('[data-product]', root).forEach((el) => {
      if (el.dataset.pdReady) return;
      el.dataset.pdReady = '1';

      const variantsEl = $('[data-variants]', el);
      const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      const fieldsets = $$('[data-option-index]', el);
      const save = $('[data-save]', el);

      const selected = () =>
        fieldsets.map((fs) => {
          const checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });

      const update = () => {
        // Gewählter Wert in der Legende ohne Klammern
        fieldsets.forEach((fs) => {
          const out = $('[data-option-current]', fs);
          const checked = $('input:checked', fs);
          if (out && checked) out.textContent = clean(checked.value);
        });

        // Sparen-Hinweis passend zur gewählten Variante
        if (!save) return;
        const opts = selected();
        const variant = variants.length === 1
          ? variants[0]
          : variants.find((v) => v.options.every((o, i) => o === opts[i]));
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          const abs = variant.compare_at_price - variant.price;
          const pct = Math.round((abs * 100) / variant.compare_at_price);
          save.textContent = `Du sparst ${money(abs)} (−${pct}%)`;
          save.hidden = false;
        } else {
          save.hidden = true;
        }
      };

      $$('.option__input', el).forEach((input) => input.addEventListener('change', update));
      update();
    });
  }

  const init = () => initProductExtras(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', (e) => initProductExtras(e.target));
})();
